import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all causeCodes
export const getCauseCodes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/cause-codes`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cause-codes:", error.response?.data || error);
    throw error;
  }
};

// GET a single causeCode
export const getCauseCodeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/cause-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cause-codes:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new causeCode
export const createCauseCode = async (causeCodeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/cause-codes`, causeCodeData);
    return response.data;
  } catch (error) {
    console.error("Error creating cause-codes:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing causeCode
export const updateCauseCode = async (id, causeCodeData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/cause-codes/${id}`, causeCodeData);
    return response.data;
  } catch (error) {
    console.error("Error updating cause-codes:", error.response?.data || error);
    throw error;
  }
};

// DELETE a causeCode
export const deleteCauseCode = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/cause-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting cause-codes:", error.response?.data || error);
    throw error;
  }
};

// CHECK for duplicate causeCode by code or name
export const checkCauseCodeDuplicate = async ({ code, name, excludeId }) => {
  try {
    const params = new URLSearchParams();
    if (code) params.append('code', code);
    if (name) params.append('name', name);
    if (excludeId) params.append('excludeId', excludeId);
    const response = await axiosInstance.get(
      `${API_URL}/cause-codes/check-duplicate?${params.toString()}`,
      {      },
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error checking cause-code duplicate:',
      error.response?.data || error,
    );
    throw error;
  }
};
